import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, Globe2Icon, CalendarIcon, ShieldCheckIcon } from 'lucide-react';
export function SocialProofBar() {
  const stats = [{
    icon: <CheckCircle2Icon className="w-8 h-8 text-teal mb-3" data-id="element-216" />,
    value: '99+',
    label: 'Projects Delivered'
  }, {
    icon: <Globe2Icon className="w-8 h-8 text-teal mb-3" data-id="element-217" />,
    value: '9',
    label: 'Countries Served'
  }, {
    icon: <CalendarIcon className="w-8 h-8 text-teal mb-3" data-id="element-218" />,
    value: '8+',
    label: 'Years in Business'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8 text-teal mb-3" data-id="element-219" />,
    value: 'Trusted by',
    label: 'Edenrobe, Furor & More'
  }];
  return <section className="bg-navy py-12 border-y border-navy-light/20" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center" data-id="element-222">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center" data-id="element-223">
              {stat.icon}
              <h3 className="text-3xl font-bold font-heading text-white mb-1" data-id="element-224">
                {stat.value}
              </h3>
              <p className="text-sm text-teal-light font-medium uppercase tracking-wider" data-id="element-225">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}